export const downloadAsHtml5 = (htmlContent, title) => {
  // Estructura HTML con estilos institucionales integrados
  const fullHtmlDocument = `
<!DOCTYPE html>
<html lang="es">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>${title} - IDC Notas</title>
</head>
<body style="font-family: Arial, Helvetica, sans-serif; background-color: #f4f5f7; color: #333333; padding: 2rem; margin: 0;">
    <main style="max-width: 800px; margin: 0 auto; background-color: #ffffff; padding: 3rem; border-top: 6px solid #c8102e; box-shadow: 0 4px 6px rgba(0,0,0,0.1); border-radius: 4px;">
        <h1 style="color: #c8102e; font-size: 24px; border-bottom: 1px solid #e5e7eb; padding-bottom: 10px; margin-bottom: 20px;">
            ${title}
        </h1>
        <div style="line-height: 1.6; font-size: 16px;">
            ${htmlContent}
        </div>
    </main>
</body>
</html>`;

  const blob = new Blob([fullHtmlDocument], { type: 'text/html' });
  const url = URL.createObjectURL(blob);
  
  const a = document.createElement('a');
  a.href = url;
  a.download = `nota-${title.replace(/\s+/g, '-').toLowerCase()}.html`;
  document.body.appendChild(a);
  a.click();
  
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};